import React from 'react'
import objectPath from 'object-path'
import NumberFormat from 'react-number-format'
import { isNumber } from 'designer/component/action/Data'

export const createSummaryRowHelper = ({
  tableColumnList,
  setHasSummaryRow,
  uischema,
  totalCount,
}) => {
  const checkHasSummaryRow = () => {
    let foundSummaryRowColumn = tableColumnList.filter(
      ({ summaryRowType }) => summaryRowType,
    )
    setHasSummaryRow(foundSummaryRowColumn.length > 0)
  }

  const getSummaryValue = (data, field) => {
    let sumValue = 0
    data.forEach((item) => {
      let value = objectPath.get(item, field)
      if (value && isNumber(value)) {
        sumValue += Number(value)
      }
    })
    sumValue = parseFloat(sumValue.toFixed(2))
    return sumValue
  }

  const renderSummaryRow = ({ column, data }) => {
    let textAlign = column.textAlign || 'left'
    let summaryColumnColor = column.summaryColumnColor || 'white'
    let style = {
      background: summaryColumnColor,
      fontWeight: 'bold',
      textAlign: textAlign,
      padding: uischema.rowPadding,
    }

    if (column?.summaryRowType === 'total') {
      let field = column.field
      let sumValue = getSummaryValue(data, field)
      return {
        value: (
          <NumberFormat
            name={column.field}
            thousandSeparator
            value={parseFloat(Number(sumValue).toFixed(2))}
            displayType="text"
          />
        ),
        style,
      }
    }
    if (column?.summaryRowType === 'custom') {
      return {
        value: column?.summaryRowValue,
        style,
      }
    }
    if (column?.summaryRowType === 'count') {
      return {
        value: `รวม ${totalCount} รายการ`,
        style,
      }
    }
    return undefined
  }

  return {
    checkHasSummaryRow,
    getSummaryValue,
    renderSummaryRow,
  }
}
